import React from 'react';
import { Card } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Get, Put } from '@app/utils/httpProvider';
import { CHUNGCHI_API } from '@app/utils/apiUrl';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { messageError, messageToast, status200 } from '../../../../utils/define';
import { URI_INTERNAL } from '../../../../utils/pathLocations';
import ChungChiForm from './ChungChiForm';

const schema = yup.object().shape({
    accountId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage),
    trichYeuId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage),
    fileManagerId: yup.string().uuid(messageError.emptyMessage).notOneOf(['00000000-0000-0000-0000-000000000000'], messageError.emptyMessage).required(messageError.emptyMessage)
});

const ChungChiEdit = () => {
    const history = useHistory();
    const queryClient = useQueryClient();
    const location = useLocation();
    const params = new URLSearchParams(location.search.substring(1));
    const itemId = params.get('id');

    const itemQuery = useQuery(['chungChi', itemId], () => Get(CHUNGCHI_API.GET_ITEM, itemId), {
        enabled: !!itemId
    });

    const editMutation = useMutation((value) => Put(CHUNGCHI_API.UPDATE_ITEM, itemId, value));

    const handleEdit = (values) => {
        const model = { ...values };

        editMutation.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastUpdateError);
                } else {
                    toast.success(messageToast.messageToastUpdateSuccess);
                    queryClient.invalidateQueries(['chungChi', itemId]);
                    queryClient.invalidateQueries('chungChiData');
                    history.push(URI_INTERNAL.CHUNGCHI_PATH);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    if (itemQuery.isLoading) {
        return <div>Đang tải....</div>;
    }

    if (itemQuery.isError || !itemQuery.data) {
        return <div>Có lỗi xảy ra hoặc không tìm thấy chứng chỉ</div>;
    }

    const currentData = itemQuery.data;

    return (
        <Card>
            <Card.Header as="h5">Sửa chứng chỉ</Card.Header>
            <Card.Body>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(values) => handleEdit(values)}
                    initialValues={{
                        accountId: currentData.accountId || currentData.AccountId || '',
                        trichYeuId: currentData.trichYeuId || currentData.TrichYeuId || '',
                        fileManagerId: currentData.fileManagerId || currentData.FileManagerId || '',
                        description: currentData.description || currentData.Description || ''
                    }}
                >
                    {(formik) => (
                        <ChungChiForm formik={formik} isSaving={editMutation.isLoading} isEdit={true} />
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default ChungChiEdit;
